import {Component, inject} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {TranslationService} from '../../services/translation.service';
import {LoginService} from '../login/login.service';
import {ApplyIfNotEmptyDirective} from '../../directives/apply-if-not-empty.directive';

/**
 * Info-Seite für SSO-Gast-Accounts: erklärt einheitlich, dass die gewünschte Aktion mit einem
 * Gast-Zugang nicht möglich ist, und bietet das Abmelden an. Angesteuert vom
 * `GuestAccountInterceptor` und vom `GuestAccountGuard`.
 */
@Component({
  selector: 'app-guest-user-information',
  templateUrl: './guest-user-information.component.html',
  styleUrls: ['./guest-user-information.component.css'],
  imports: [
    ApplyIfNotEmptyDirective,
    MatButton
  ],
  standalone: true
})
export class GuestUserInformationComponent {
  // Fallback, solange der Key noch nicht in HUP_CFG_Translations steht: getTranslation liefert für
  // unbekannte Keys einen Leerstring - der Nutzer stünde sonst vor einer leeren Seite.
  private static readonly DEFAULT_MESSAGE =
    'Diese Aktion ist mit einem Gast-Zugang nicht möglich. Bitte melden Sie sich mit Ihrem persönlichen Konto an.';

  translationService = inject(TranslationService);

  private readonly loginService = inject(LoginService);

  get message(): string {
    const translation = this.translationService.getTranslation('guestUser.informationMessage');
    return translation?.trim() ? translation : GuestUserInformationComponent.DEFAULT_MESSAGE;
  }

  logout(): void {
    this.loginService.logout();
  }
}
